import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ChatService } from '@/services/chat.service';
import { LoaderService } from '@/services/loader.service';
import { LoaderComponent } from '@/core/components/loader/loader.component';
import { catchError } from 'rxjs';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, LoaderComponent],
    template: `
        <router-outlet></router-outlet>
        @if (loading) {
            <app-loader />
        }
    `
})
export class AppComponent implements OnInit {
    public loading = false;
    private chatService: ChatService = inject(ChatService);
    private loaderService: LoaderService = inject(LoaderService);

    ngOnInit(): void {
        this.loaderService.loaderSubject.next(true);
        this.chatService
            .getUsers()
            .pipe(
                catchError((err) => {
                    this.loaderService.loaderSubject.next(false);
                    throw err;
                })
            )
            .subscribe(() => this.loaderService.loaderSubject.next(false));
        this.loaderService.loaderObservable.subscribe((loading) => (this.loading = loading));
    }
}
